let Model = {
  versionData: null,
  urls: {
    edit: null,
    player: null,
    data: null,
  },
  data: {},
  projektInfo: null,
  parameters: {
    projektId: null,
  },
  tempUserData: {
    scrollPos: null,
  },
};

export default Model;
